import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Newspaper, Mail, ArrowRight } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const Press = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Message envoyé ! Nous vous répondrons sous 48h.");
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-24">
        <section className="section-padding relative overflow-hidden">
          <div className="absolute inset-0 hero-glow" />
          <div className="container-custom relative z-10">
            <div className="text-center max-w-4xl mx-auto mb-12">
              <span className="text-sm font-semibold text-emerald-400 uppercase tracking-wider mb-4 block flex items-center justify-center gap-2">
                <Newspaper className="w-4 h-4" />
                Presse & Médias
              </span>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Contact <span className="text-emerald-400">Presse</span>
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Vous êtes journaliste, blogueur ou influenceur ? Nous serions ravis de collaborer avec vous.
              </p>
            </div>

            <div className="max-w-lg mx-auto">
              <form onSubmit={handleSubmit} className="p-6 rounded-xl bg-card border border-border space-y-4">
                <div>
                  <Label htmlFor="press-name">Nom / Média</Label>
                  <Input
                    id="press-name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Votre nom ou média"
                    className="mt-1.5"
                    required
                  />
                </div>
                <div>
                  <Label htmlFor="press-email">Email</Label>
                  <Input
                    id="press-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="email@example.com"
                    className="mt-1.5"
                    required
                  />
                </div>
                <div>
                  <Label htmlFor="press-message">Message</Label>
                  <Textarea
                    id="press-message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Décrivez votre demande..."
                    className="mt-1.5 min-h-[120px]"
                    required
                  />
                </div>
                <Button variant="gradient" size="lg" className="w-full" type="submit">
                  <Mail className="w-4 h-4" />
                  Envoyer
                </Button>
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Press;
